import { render, staticRenderFns } from "./ItemListItem.vue?vue&type=template&id=4bc7d060"
import script from "./ItemListItem.vue?vue&type=script&lang=js"
export * from "./ItemListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports